import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';
import { SparkleField } from '../components/SparkleField';
import { Lock, Sparkles } from 'lucide-react';

export default function AdminLogin() {
  const { login, user } = useAuth();
  const nav = useNavigate();
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [err, setErr] = useState('');
  const [loading, setLoading] = useState(false);

  React.useEffect(() => { if (user) nav('/admin'); }, [user, nav]);

  const onSubmit = async (e) => {
    e.preventDefault();
    setErr('');
    setLoading(true);
    try {
      await login(username, password);
      nav('/admin');
    } catch (ex) {
      setErr(ex?.response?.data?.detail || 'Error al iniciar sesión');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen relative flex items-center justify-center hero-radial px-4 py-10">
      <SparkleField mobileCount={2} desktopCount={6} />
      <form
        onSubmit={onSubmit}
        data-testid="login-form"
        className="relative w-full max-w-md bg-white/90 backdrop-blur-xl border border-pinky-100 rounded-3xl shadow-2xl p-8 space-y-5"
      >
        <div className="text-center">
          <div className="mx-auto h-14 w-14 rounded-2xl bg-pinky-100 flex items-center justify-center text-pinky-600">
            <Lock className="h-7 w-7" strokeWidth={1.6} />
          </div>
          <h1 className="mt-4 font-display text-3xl text-slate-900">Panel de Administración</h1>
          <p className="mt-2 text-sm text-slate-500 flex items-center justify-center gap-1">
            <Sparkles className="h-3.5 w-3.5 text-pinky-400" /> Gifts GT
          </p>
        </div>

        <div>
          <Label htmlFor="username">Usuario</Label>
          <Input
            id="username"
            data-testid="login-username"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            placeholder="Tu usuario"
            className="mt-1 rounded-xl h-12"
            required
          />
        </div>
        <div>
          <Label htmlFor="password">Contraseña</Label>
          <Input
            id="password"
            type="password"
            data-testid="login-password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            placeholder="••••••••"
            className="mt-1 rounded-xl h-12"
            required
          />
        </div>

        {err && <p data-testid="login-error" className="text-sm text-rose-600 bg-rose-50 border border-rose-200 rounded-xl p-3">{err}</p>}

        <Button
          type="submit"
          data-testid="login-submit"
          disabled={loading}
          className="btn-pink w-full h-12 rounded-full font-bold"
        >
          {loading ? 'Ingresando…' : 'Iniciar sesión'}
        </Button>

        <a href="/" className="block text-center text-sm text-slate-500 hover:text-pinky-600">← Volver al catálogo</a>
      </form>
    </div>
  );
}
